import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types'
import { translate, Trans } from "react-i18next";
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import { get, postWithHeaders } from "../../../server/actions"
import { numberOnly } from '../../../server/util.js'
import NotificationSystem from 'react-notification-system';
import { _addNotification, _addNotificationError } from '../../../server/util';
import { IncomFreqency, incomeModal, childIncomeTypeList } from '../../Parent/SchoolLunchBreakfastProgram/schoolLunchBreakfastModal'
import Select, { StylesConfig } from 'react-select';

const initialState = {
    loading: false,
    disablebtn: false,
    studentsInfo: [],
    studentsList: [],
    childFname: '',
    childLname: '',
    adultFname: '',
    adultLname: '',
    childList: [],
    adultList: [],
    person: [{
        fname: '',
        lname: '',
        mname: '',
        filledTheApplication: true,
        personType: 'Adult',
        assistancePrograms: [
            {
                id: 1,
                name: 'Supplemental Nutrition Assistance Program (SNAP)',
                accronym: 'SNAP',
                caseNumber: '',
                isApplicable: false
            },
            {
                id: 2,
                name: 'Temporary Assistance for Needy Families (TANF)',
                accronym: 'TANF',
                caseNumber: '',
                isApplicable: false
            },
            {
                id: 3,
                name: 'Food Distribution Program on Indian Reservations (FDPIR)',
                accronym: 'FDPIR',
                caseNumber: '',
                isApplicable: false
            }
        ],
        income: [],
        contact: {
            phone: '',
            email: '',
            street1: '',
            street2: '',
            city: '',
            state: '',
            zip: '',
        },
        noIncome: true,
        totalIncome: null,
        ssn: '',
        noSSN: false,
        grade: '',
        liveUnderFosterCare: false,
        homelessOrMigrantOrRunaway: null,
        mcKinneyVentoHomeless: null,
        migrantEducationPrg: null,
        runaway: null,
        headStart: null,
        ethenticity: null,
        race: [],
        isFreeMeal: false,
        studentRecId: 0,
        decisionReason: null,
        category: null,
        actualPrg: null,
        mealSchoolId: null,
        schoolYear: null
    }],
    selectedStudent: '',
    parentInfo: [],
    prmyParentEmail: '',
}

class SelectCell extends Component {
    handleChange = (event) => {
        const selectedValue = event.target.value;
        this.props.onSelectChange(selectedValue);
    };
    render() {
        const { options, selectedValue } = this.props;
        return (
            <select className={'form-control'} value={selectedValue} onChange={this.handleChange}>
                <option value="">Select a student</option>
                {options.map((option, index) => (
                    <option key={index} value={option.studentRecId}>
                        {`${option.fname} ${option.lname}`}
                    </option>
                ))}
            </select>
        );
    }
}

class NewSchoolMealProgramApplication extends Component {
    constructor(props) {
        super(props)
        this.state = {
            ...JSON.parse(JSON.stringify(initialState)),
            allStudents: [],
            rSelectDDItem: {}
        }
    }

    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
        this.getStudentInfo();
    }



    handleSelectChange = (selectedValue) => {
        this.setState({ selectedStudent: selectedValue });
    };

    handleAddStudent = (event) => {
        event.preventDefault()
        const { selectedStudent, studentsList, studentsInfo } = this.state;
        if (selectedStudent !== '') {
            const selectedStudentObj = studentsInfo.find(stu => stu.studentRecId == selectedStudent)
            if (!studentsList.some(student => student.studentRecId === selectedStudentObj.studentRecId)) {
                this.setState({
                    studentsList: [...studentsList, selectedStudentObj],
                    selectedStudent: ''
                });
            } else {
                this.setState({ selectedStudent: '' })
            }
        }
    };

    handleRemoveStudent = (event, id) => {
        event.preventDefault()
        const { studentsList } = this.state;
        const finalStudentObj = studentsList.filter(stu => stu.studentRecId !== id)
        this.setState({ studentsList: finalStudentObj })
    };



    handleAddChild = (event) => {
        event.preventDefault()
        const { childFname, childLname, childList } = this.state;
        if (childFname == '' || childLname == '') {
            _addNotificationError('Please enter child details.', this);
            return false;
        }
        if (childFname !== '') {
            const obj = {
                fname: childFname,
                lname: childLname,
                grade: '',
                personType: 'Child',
                liveUnderFosterCare: false,
                runaway: null,
                homelessOrMigrantOrRunawayOptions: [],
                mcKinneyVentoHomeless: null,
                migrantEducationPrg: null,
                headStart: null,
                filledTheApplication: false,
                income: [],
                noIncome: true,
                TotalIncome: 0,
                ethenticity: '',
                race: [],
                isFreeMeal: false,
                id: null,
                isSelected: true,
                mealSchoolId: null,
                schoolYear: null
            }
            this.setState({ childList: [...childList, obj], childFname: '', childLname: '' })
        }
    }

    handleRemoveChild = (event, id) => {
        event.preventDefault()
        const { childList } = this.state;
        const finalChildObj = childList.filter((item, index) => index !== id)
        this.setState({ childList: finalChildObj })
    };

    handleAddAdult = (event) => {
        event.preventDefault()
        const { adultFname, adultLname, adultList } = this.state;
        if (adultFname == '' || adultLname == '') {
            _addNotificationError('Please enter adult details.', this);
            return false;
        }
        if (adultFname !== '') {
            const obj = {
                fname: adultFname,
                lname: adultLname,
                grade: '',
                personType: 'Adult',
                liveUnderFosterCare: false,
                runaway: null,
                homelessOrMigrantOrRunawayOptions: [],
                mcKinneyVentoHomeless: null,
                migrantEducationPrg: null,
                headStart: null,
                filledTheApplication: false,
                income: [],
                noIncome: true,
                TotalIncome: 0,
                ethenticity: '',
                race: [],
                isFreeMeal: false,
                id: null,
                isSelected: true,
                mealSchoolId: null,
                schoolYear: null
            }
            this.setState({ adultList: [...adultList, obj], adultFname: '', adultLname: '' })
        }
    }

    handleRemoveAdult = (event, id) => {
        event.preventDefault()
        const { adultList } = this.state;
        const finalAdultObj = adultList.filter((item, index) => index !== id)
        this.setState({ adultList: finalAdultObj })
    };

    resetState = () => {
        this.setState({ ...JSON.parse(JSON.stringify(initialState)) });
        this.context.router.history.push('/schoolAdmin/schoolMealProgram');
    }
    disable_enableBtn = (isDisable = false) => {
        return new Promise((resolve, reject) => {
            this.setState({ disablebtn: isDisable });
            resolve(true);
        });
    }

    onFormSubmit = (e) => {
        e.preventDefault()
        let schoolId = sessionStorage.getItem('SchoolId')
        let schoolYear = sessionStorage.getItem('schoolYearValue')
        const todayDate = new Date().toLocaleDateString('en-US', {
            month: '2-digit',
            day: '2-digit',
            year: 'numeric'
        }).replace(/\//g, '');

        // if (this.state.person[0].contact.email == '') {
        //     _addNotificationError('Please enter parent email.', this);
        //     return false;
        // }

        if (this.state.studentsList.length > 0) {
            const studentRecIds = this.state.studentsList.map(student => student.studentRecId).join(', ');
            const _person = this.state.person
            let _householdAppInfo = []
            let requestBody = {
                date: todayDate,
                status: "pending",
                studentRecIds: studentRecIds,
                mealSchoolId: parseInt(schoolId),
                prmyParentEmail: this.state.prmyParentEmail,
                schoolYear: schoolYear
            }

            _householdAppInfo.push(this.state.person[0])
            this.state.studentsList.map(stuObj => _householdAppInfo.push(stuObj));
            this.state.childList.map(childObj => _householdAppInfo.push(childObj));
            this.state.adultList.map(adultObj => _householdAppInfo.push(adultObj));

            requestBody['householdAppInfo'] = _householdAppInfo

            let headers = {
                'Content-Type': 'application/json'
            };

            if (_person[0].fname == '' || _person[0].lname == '') {
                _addNotificationError('Please fill the Mandatory fields.', this);
                return false;
            }
            let allIncomeList = [];
            this.state.studentsList.map(st => {
                if ((st.income || []).length > 0) {
                    allIncomeList = [...allIncomeList, ...st.income];
                }
            });
            this.state.childList.map(ch => {
                if ((ch.income || []).length > 0) {
                    allIncomeList = [...allIncomeList, ...ch.income];
                }
            });

            if ((_person[0].income || []).length > 0) {
                allIncomeList = [...allIncomeList, ..._person[0].income];
            }

            this.state.adultList.map(a => {
                if ((a.income || []).length > 0) {
                    allIncomeList = [...allIncomeList, ...a.income];
                }
            });

            if (!allIncomeList.every(inc => {
                return inc.source != '' && inc.frequency != '' && parseFloat(inc.amount === '' ? 0 : inc.amount) > 0
            })) {
                _addNotificationError('Please fill income information', this);
                return false;
            }
            if (this.state.person[0].noSSN === false && this.state.person[0].ssn === '') {
                _addNotificationError('Please enter SSN or select ‘No SSN’', this);
                return false;
            }

            this.disable_enableBtn(true);
            postWithHeaders(`/householdApplication?access_token=`, JSON.stringify(requestBody), headers).then((resp) => {
                // if (!resp.ok) {
                //     //throw Error(resp.errorMessage);
                // }
                return resp.json();
            }).then(data => {
                if (data.statusCode === 200) {
                    _addNotification(data.statusMessage, this);
                    this.disable_enableBtn();
                    this.resetState();
                }
                 else if (data.statusCode === 400) {
                     _addNotificationError(data.statusMessage, this);
                        this.disable_enableBtn();
                    } 
                    else{
                        throw Error(data.statusMessage);
                    }
            }).catch(
                (error) => {
                    console.log('Details not saved', error);
                    _addNotificationError('Please try again!', this);
                    this.disable_enableBtn();
                }
            );

        } else {
            _addNotificationError('Student must be selected.', this);
        }


    }
    onCancel = (e) => {
        this.context.router.history.push('/schoolAdmin/schoolMealProgram');
    }

    handleOnChange = (selectedOption) => {
        const { studentsList } = this.state;
        console.log(selectedOption);
        const selectedStu = this.state.allStudents.find(stu => stu.studentId === selectedOption.value);
        const otherStudents = this.state.allStudents.filter(stu => {
            const emailList = [stu.parentUser.userName];
            if ((stu.parentUser.parentAltEmail || '').length > 0) {
                emailList.push(stu.parentUser.parentAltEmail);
            }
            if (selectedStu.parentUser.parentAltEmail) {
                return emailList.includes(selectedStu.parentUser.userName) || emailList.includes(selectedStu.parentUser.parentAltEmail);

            } else {
                return emailList.includes(selectedStu.parentUser.userName);
            }

        });
        let _person = this.state.person
        _person[0].fname = '';//selectedStu.fname
        _person[0].mname = '';//selectedStu.mname
        _person[0].lname = '';//selectedStu.lname
        _person[0].contact.email = selectedStu.parentUser.userName;
        const selectedStudentObj = otherStudents.find(stu => stu.studentRecId == selectedStu.studentRecId);
        if (!studentsList.some(student => student.studentRecId === selectedStudentObj.studentRecId)) {
            this.setState({
                studentsList: [...otherStudents],
                selectedStudent: ''
            });
        } else {
            this.setState({ selectedStudent: '' })
        }

        this.setState({ studentsInfo: otherStudents, person: _person, prmyParentEmail: _person[0].contact.email });

    }

    getStudentInfo = () => {
        let schoolId = sessionStorage.getItem('SchoolId')
        let schoolYear = sessionStorage.getItem('schoolYearValue')
        const parentEmail = this.state.person
        this.setState({ loading: true });
        get(`/studentUsers/search/findByIsActiveAndMealSchoolSchoolIdAndSchoolYear?isActive=true&schoolId=${schoolId}&schoolYear=${schoolYear}&access_token=`)
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.json()
                    .catch(() => {
                        // Handle parsing error
                        console.log('Error parsing JSON data');
                        _addNotificationError('Issue in fetching Students Info. Please try again!', this);
                        // You can return null or perform any other action for this scenario
                        return {};
                    });
            }).then(data => {
                if (Object.entries(data._embedded.studentUsers).length > 0) {
                    let studentObj = data._embedded.studentUsers.map(member => ({
                        fname: member.firstName,
                        lname: member.lastName,
                        grade: member.gradeName,
                        personType: 'Student',
                        liveUnderFosterCare: false,
                        runaway: null,
                        homelessOrMigrantOrRunawayOptions: [],
                        mcKinneyVentoHomeless: null,
                        migrantEducationPrg: null,
                        headStart: null,
                        filledTheApplication: false,
                        income: [],
                        noIncome: true,
                        TotalIncome: 0,
                        ethenticity: '',
                        race: [],
                        isFreeMeal: false,
                        studentId: parseInt(member._links.self.href.split('/').pop()),
                        studentRecId: parseInt(member._links.self.href.split('/').pop()),
                        id: null,
                        isSelected: true,
                        mealSchoolId: null,
                        schoolYear: null,
                        parentUser: member.parentuser
                    }))


                    this.setState({ allStudents: studentObj })

                } else {
                    _addNotificationError('No Students are mapped to this Email Id.', this);
                }
            }).catch();
    }

    render() {

        const { studentsList, studentsInfo, childList, person, adultList, disablebtn, allStudents } = this.state;

        return (
            <div className='container' style={{ marginTop: '15px', fontSize: '12px' }}>
                <NotificationSystem ref="notificationSystem" />
                <Form>
                    <div className="row parent-info-section">
                        <div className="col-xs-12">
                            <div className="row">
                                <div className="col-md-9 col-sm-12 col-xs-12 sectionTitle" style={{ marginBottom: '5px' }}>
                                    <h2>
                                        <span>HOUSEHOLD APPLICATION FOR FREE AND REDUCED PRICE SCHOOL MEALS</span>
                                    </h2>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-5'>
                                    <label><Trans>Select Student</Trans></label>
                                    <Select
                                        menuPortalTarget={document.body}
                                        onChange={(selectedOption) => {
                                            this.setState({ rSelectDDItem: selectedOption });
                                            this.handleOnChange(selectedOption);
                                        }}
                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                        // defaultValue={colourOptions[2]}
                                        options={allStudents.map(stu => {
                                            return { value: stu.studentRecId, label: `${stu.fname} ${stu.lname} - [Grade: ${stu.grade}]` }
                                        })}
                                    // styles={colourStyles}
                                    />

                                </div>
                            </div>
                            <div className="row">
                                <div className='col-md-12' style={{ marginTop: '10px' }}>
                                    <label>Parent Contact Info</label>
                                </div>
                                <div className="col-md-3">
                                    <label><Trans>First Name</Trans>*</label>
                                    <Input
                                        type="text"
                                        name="fname"
                                        className="form-control"
                                        onChange={(e) => {
                                            let _person = this.state.person
                                            _person[0].fname = e.target.value
                                            this.setState({ person: _person })
                                        }}
                                        value={this.state.person[0].fname}
                                    />
                                </div>
                                <div className="col-md-2">
                                    <label><Trans>Middle Name</Trans></label>
                                    <Input
                                        type="text"
                                        name="mname"
                                        className="form-control"
                                        onChange={(e) => {
                                            let _person = this.state.person
                                            _person[0].mname = e.target.value
                                            this.setState({ person: _person })
                                        }}
                                        value={this.state.person[0].mname}
                                    />
                                </div>
                                <div className="col-md-3">
                                    <label><Trans>Last Name</Trans> *</label>
                                    <Input
                                        type="text"
                                        name="lname"
                                        className="form-control"
                                        onChange={(e) => {
                                            let _person = this.state.person
                                            _person[0].lname = e.target.value
                                            this.setState({ person: _person })
                                        }}
                                        value={this.state.person[0].lname}
                                    />
                                </div>
                                <div className="col-md-3 form-group">
                                    <label><Trans>E-Mail</Trans> </label>
                                    <Input
                                        type="text"
                                        name="parentEmail"
                                        className="form-control"
                                        //onBlur={this.handleOnBlur}
                                        onChange={(e) => {
                                            let _person = this.state.person
                                            _person[0].contact.email = e.target.value
                                            this.setState({ person: _person })
                                        }}
                                        value={this.state.person[0].contact.email}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row student-info-section">
                        <div className="col-md-12">
                            <div className="table-responsive">
                                <table className="table table-bordered" cellPadding="0" cellSpacing="0">
                                    <thead>
                                        <tr>
                                            <th rowSpan="2"><Trans>First Name</Trans></th>
                                            <th rowSpan="2"><Trans>Last Name</Trans></th>
                                            <th rowSpan="2"><Trans>Grade</Trans></th>
                                            <th colSpan="2"><Trans>Student?</Trans></th>
                                            {/* <th rowSpan="2"><Trans>Foster Child</Trans></th> */}
                                            <th rowSpan="2" ><Trans>Homeless, Migrant, Runaway, Foster Child, Head Start</Trans></th>
                                            <th rowSpan="2" ></th>
                                        </tr>
                                        <tr>
                                            <th ><Trans>Yes</Trans></th>
                                            <th ><Trans>No</Trans></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            studentsList.map((student, k) => {
                                                return (
                                                    <tr key={k}>
                                                        <td style={{ padding: '2px' }}>
                                                            <input className="form-control" data-idx={k} value={student.fname} type="text" /></td>
                                                        <td style={{ padding: '2px', width: '25%' }}>
                                                            <input className="form-control" data-idx={k} value={student.lname} type="text" /></td>
                                                        <td style={{ padding: '2px', width: '9%' }}>
                                                            <input className="form-control" data-idx={k} type="text" value={student.grade} /></td>
                                                        <td style={{ padding: '2px', textAlign: 'center', verticalAlign: 'middle', width: '5%' }}>
                                                            <input className="rdbox" data-idx={k} type="radio" checked={true} disabled /></td>
                                                        <td style={{ padding: '2px', textAlign: 'center', verticalAlign: 'middle', width: '5%' }}>
                                                            <input className="rdbox" data-idx={k} type="radio" checked={false} disabled /></td>
                                                        {/*  <td style={{ padding: '2px', textAlign: 'center', verticalAlign: 'middle', width: '7%' }}>
                                                            <input className="checkbox-inline" data-idx={k} type="checkbox" onChange={(e) => {
                                                                let idx = e.target.getAttribute('data-idx')
                                                                let _studentsList = this.state.studentsList;
                                                                _studentsList[idx].liveUnderFosterCare = e.target.checked;
                                                                this.setState({ studentsList: _studentsList })
                                                            }}
                                                                checked={student.liveUnderFosterCare === true} /></td> */}
                                                        <td style={{ padding: '2px', verticalAlign: 'middle', width: '9%' }}>
                                                            <label className="checkbox-inline" style={{ display: 'block' }}>
                                                                <input type="checkbox" data-idx={k} value="Homeless" onChange={(e) => {
                                                                    let idx = e.target.getAttribute('data-idx')
                                                                    let _studentsList = this.state.studentsList;
                                                                    if (e.target.checked) {
                                                                        _studentsList[idx].homelessOrMigrantOrRunawayOptions = [];
                                                                        _studentsList[idx].homelessOrMigrantOrRunawayOptions.push(e.target.value);
                                                                        _studentsList[idx].liveUnderFosterCare = false;
                                                                        _studentsList[idx].headStart = false;
                                                                    } else {
                                                                        let index = _studentsList[idx].homelessOrMigrantOrRunawayOptions.indexOf('Homeless')
                                                                        _studentsList[idx].homelessOrMigrantOrRunawayOptions.splice(index, 1)
                                                                    }
                                                                    this.setState({ studentsList: _studentsList })
                                                                }}
                                                                    checked={(student.homelessOrMigrantOrRunawayOptions || []).includes('Homeless')}
                                                                /><Trans>Homeless</Trans>
                                                            </label>
                                                            <label className="checkbox-inline" style={{ marginLeft: '0px', display: 'block' }}>
                                                                <input type="checkbox" data-idx={k} value="Migrant" onChange={(e) => {
                                                                    let idx = e.target.getAttribute('data-idx')
                                                                    let _studentsList = this.state.studentsList;
                                                                    if (e.target.checked) {
                                                                        _studentsList[idx].homelessOrMigrantOrRunawayOptions = [];
                                                                        _studentsList[idx].homelessOrMigrantOrRunawayOptions.push(e.target.value);
                                                                        _studentsList[idx].liveUnderFosterCare = false;
                                                                        _studentsList[idx].headStart = false;
                                                                    } else {
                                                                        let index = _studentsList[idx].homelessOrMigrantOrRunawayOptions.indexOf('Migrant')
                                                                        _studentsList[idx].homelessOrMigrantOrRunawayOptions.splice(index, 1)
                                                                    }
                                                                    this.setState({ studentsList: _studentsList })
                                                                }}
                                                                    checked={(student.homelessOrMigrantOrRunawayOptions || []).includes('Migrant')}
                                                                /><Trans>Migrant</Trans>
                                                            </label>
                                                            <label className="checkbox-inline" style={{ marginLeft: '0px', display: 'block' }}>
                                                                <input type="checkbox" data-idx={k} value="Runaway" onChange={(e) => {
                                                                    let idx = e.target.getAttribute('data-idx')
                                                                    let _studentsList = this.state.studentsList;
                                                                    if (e.target.checked) {
                                                                        _studentsList[idx].homelessOrMigrantOrRunawayOptions = [];
                                                                        _studentsList[idx].homelessOrMigrantOrRunawayOptions.push(e.target.value);
                                                                        _studentsList[idx].liveUnderFosterCare = false;
                                                                        _studentsList[idx].headStart = false;
                                                                    } else {
                                                                        let index = _studentsList[idx].homelessOrMigrantOrRunawayOptions.indexOf('Runaway')
                                                                        _studentsList[idx].homelessOrMigrantOrRunawayOptions.splice(index, 1)
                                                                    }
                                                                    this.setState({ studentsList: _studentsList })
                                                                }}
                                                                    checked={(student.homelessOrMigrantOrRunawayOptions || []).includes('Runaway')}
                                                                /><Trans>Runaway</Trans>
                                                            </label>
                                                            <label className="checkbox-inline" style={{ marginLeft: '0px', display: 'block' }}>
                                                                <input className="checkbox-inline" data-idx={k} type="checkbox" onChange={(e) => {
                                                                    let idx = e.target.getAttribute('data-idx')
                                                                    let _studentsList = this.state.studentsList;
                                                                    _studentsList[idx].liveUnderFosterCare = e.target.checked;
                                                                    _studentsList[idx].homelessOrMigrantOrRunawayOptions = [];
                                                                    _studentsList[idx].headStart = false;
                                                                    this.setState({ studentsList: _studentsList })
                                                                }}
                                                                    checked={student.liveUnderFosterCare === true} />Foster Child
                                                            </label>
                                                            <label className="checkbox-inline" style={{ marginLeft: '0px', display: 'block' }}>
                                                                <input className="checkbox-inline" data-idx={k} type="checkbox" value="HeadStart" onChange={(e) => {
                                                                    let idx = e.target.getAttribute('data-idx')
                                                                    let _studentsList = this.state.studentsList;
                                                                    _studentsList[idx].headStart = e.target.checked;
                                                                    _studentsList[idx].liveUnderFosterCare = false;
                                                                    _studentsList[idx].homelessOrMigrantOrRunawayOptions = [];
                                                                    this.setState({ studentsList: _studentsList })
                                                                }}
                                                                    checked={student.headStart === true} /><Trans>Head Start</Trans>
                                                            </label>
                                                        </td>
                                                        <td className="text-center">
                                                            {k == 0 ? null : <button className="btn-facebook-link" style={{ fontSize: '12px' }} onClick={(event) => this.handleRemoveStudent(event, student.studentRecId)}>
                                                                <i className="fa fa-trash"></i></button>}
                                                        </td>
                                                    </tr>
                                                )
                                            })

                                        }

                                    </tbody>
                                    <tfoot>
                                        <tr></tr>
                                        <tr>
                                            <td colSpan={"4"}>
                                                <SelectCell options={studentsInfo} selectedValue={this.state.selectedStudent} onSelectChange={this.handleSelectChange} />
                                            </td>
                                            <td colSpan="8"><button className="btn-social btn-linkedin-link pull-right" onClick={this.handleAddStudent}><Trans>Add Student</Trans></button>
                                            </td>

                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="row child-info-section">
                        <div className='col-md-12'>
                            <label>Other children in household</label>
                        </div>
                        <div className="col-md-12">
                            <div className="table-responsive">
                                <table className="table table-bordered" cellPadding="0" cellSpacing="0">
                                    <thead>
                                        <tr>
                                            <th rowSpan="2"><Trans>First Name</Trans></th>
                                            <th rowSpan="2"><Trans>Last Name</Trans></th>
                                            {/*  <th rowSpan="2"><Trans>Grade</Trans></th> */}
                                            <th colSpan="2"><Trans>Student?</Trans></th>
                                            {/* <th rowSpan="2"><Trans>Foster Child</Trans></th> */}
                                            <th rowSpan="2" ><Trans>Homeless, Migrant, Runaway, Foster Care</Trans></th>
                                            <th rowSpan="2" ></th>
                                        </tr>
                                        <tr>
                                            <th ><Trans>Yes</Trans></th>
                                            <th ><Trans>No</Trans></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            childList.map((child, x) => {
                                                return (
                                                    <tr key={x}>
                                                        <td style={{ padding: '2px' }}>
                                                            <input className="form-control" data-idx={x} value={child.fname} type="text" /></td>
                                                        <td style={{ padding: '2px', width: '25%' }}>
                                                            <input className="form-control" data-idx={x} value={child.lname} type="text" /></td>
                                                        {/*  <td style={{ padding: '2px', width: '9%' }}>
                                                            <input className="form-control" data-idx={x} type="text" value={child.grade} /></td> */}
                                                        <td style={{ padding: '2px', textAlign: 'center', verticalAlign: 'middle', width: '5%' }}>
                                                            <input className="rdbox" data-idx={x} type="radio" checked={false} disabled /></td>
                                                        <td style={{ padding: '2px', textAlign: 'center', verticalAlign: 'middle', width: '5%' }}>
                                                            <input className="rdbox" data-idx={x} type="radio" checked={true} disabled /></td>
                                                        {/* <td style={{ padding: '2px', textAlign: 'center', verticalAlign: 'middle', width: '7%' }}>
                                                            <input className="checkbox-inline" data-idx={x} type="checkbox" onChange={(e) => {
                                                                let idx = e.target.getAttribute('data-idx')
                                                                let _childList = this.state.childList;
                                                                _childList[idx]['liveUnderFosterCare'] = e.target.checked;
                                                                this.setState({ childList: _childList })
                                                            }}
                                                                checked={child.liveUnderFosterCare === true} /></td> */}
                                                        <td style={{ padding: '2px', verticalAlign: 'middle', width: '9%' }}>
                                                            <label className="checkbox-inline" style={{ display: 'block' }}>
                                                                <input type="checkbox" data-idx={x} value="Homeless" onChange={(e) => {
                                                                    let idx = e.target.getAttribute('data-idx')
                                                                    let _childList = this.state.childList;
                                                                    if (e.target.checked) {
                                                                        _childList[idx].homelessOrMigrantOrRunawayOptions.push(e.target.value);
                                                                    } else {
                                                                        let index = _childList[idx].homelessOrMigrantOrRunawayOptions.indexOf('Homeless')
                                                                        _childList[idx].homelessOrMigrantOrRunawayOptions.splice(index, 1)
                                                                    }
                                                                    this.setState({ childList: _childList })
                                                                }}
                                                                    checked={(child.homelessOrMigrantOrRunawayOptions || []).includes('Homeless')}
                                                                    disabled
                                                                /><Trans>Homeless</Trans>
                                                            </label>
                                                            <label className="checkbox-inline" style={{ marginLeft: '0px', display: 'block' }}>
                                                                <input type="checkbox" data-idx={x} value="Migrant" onChange={(e) => {
                                                                    let idx = e.target.getAttribute('data-idx')
                                                                    let _childList = this.state.childList;
                                                                    if (e.target.checked) {
                                                                        _childList[idx].homelessOrMigrantOrRunawayOptions.push(e.target.value);
                                                                    } else {
                                                                        let index = _childList[idx].homelessOrMigrantOrRunawayOptions.indexOf('Migrant')
                                                                        _childList[idx].homelessOrMigrantOrRunawayOptions.splice(index, 1)
                                                                    }
                                                                    this.setState({ childList: _childList })
                                                                }}
                                                                    checked={(child.homelessOrMigrantOrRunawayOptions || []).includes('Migrant')}
                                                                    disabled
                                                                /><Trans>Migrant</Trans>
                                                            </label>
                                                            <label className="checkbox-inline" style={{ marginLeft: '0px', display: 'block' }}>
                                                                <input type="checkbox" data-idx={x} value="Runaway" onChange={(e) => {
                                                                    let idx = e.target.getAttribute('data-idx')
                                                                    let _childList = this.state.childList;
                                                                    if (e.target.checked) {
                                                                        _childList[idx].homelessOrMigrantOrRunawayOptions.push(e.target.value);
                                                                    } else {
                                                                        let index = _childList[idx].homelessOrMigrantOrRunawayOptions.indexOf('Runaway')
                                                                        _childList[idx].homelessOrMigrantOrRunawayOptions.splice(index, 1)
                                                                    }
                                                                    this.setState({ childList: _childList })
                                                                }}
                                                                    checked={(child.homelessOrMigrantOrRunawayOptions || []).includes('Runaway')}
                                                                    disabled
                                                                /><Trans>Runaway</Trans>
                                                            </label>
                                                            <label className="checkbox-inline" style={{ marginLeft: '0px', display: 'block' }}>
                                                                <input className="checkbox-inline" data-idx={x} type="checkbox"
                                                                    disabled
                                                                    checked={child.liveUnderFosterCare === true} /><Trans>Foster Child</Trans>
                                                            </label>
                                                            <label className="checkbox-inline" style={{ marginLeft: '0px', display: 'block' }}>
                                                                <input className="checkbox-inline" data-idx={x} type="checkbox" value="HeadStart"
                                                                    disabled
                                                                    checked={child.headStart === true} /><Trans>Head Start</Trans>
                                                            </label>
                                                        </td>
                                                        <td className="text-center">
                                                            <button className="btn-facebook-link" style={{ fontSize: '12px' }} onClick={(event) => this.handleRemoveChild(event, x)}>
                                                                <i className="fa fa-trash"></i></button>
                                                        </td>
                                                    </tr>
                                                )
                                            })

                                        }

                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td>
                                                <input className="form-control" value={this.state.childFname} type="text" placeholder='First Name' onChange={(e) => this.setState({ childFname: e.target.value })} />
                                            </td>
                                            <td>
                                                <input className="form-control" value={this.state.childLname} type="text" placeholder='Last Name' onChange={(e) => this.setState({ childLname: e.target.value })} />
                                            </td>
                                            <td colSpan="7">
                                                <button className="btn-social btn-linkedin-link pull-right" onClick={this.handleAddChild}><Trans>Add Child</Trans></button>
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="row adult-info-section">
                        <div className='col-md-12'>
                            <label>Other adults in household</label>
                        </div>
                        <div className="col-md-12">
                            <div className="table-responsive">
                                <table className="table table-bordered" cellPadding="0" cellSpacing="0">
                                    <thead>
                                        <tr>
                                            <th rowSpan="2"><Trans>First Name</Trans></th>
                                            <th rowSpan="2"><Trans>Last Name</Trans></th>
                                            {/* <th rowSpan="2"><Trans>Grade</Trans></th>
                                            <th colSpan="2"><Trans>Student?</Trans></th>
                                            <th rowSpan="2"><Trans>Foster Child</Trans></th>
                                            <th rowSpan="2" ><Trans>Homeless, Migrant, Runaway</Trans></th> */}
                                            <th rowSpan="2" ></th>
                                        </tr>
                                        {/*  <tr>
                                            <th ><Trans>Yes</Trans></th>
                                            <th ><Trans>No</Trans></th>
                                        </tr> */}
                                    </thead>
                                    <tbody>

                                        {
                                            adultList.map((adult, x) => {
                                                return (
                                                    <tr key={x}>
                                                        <td style={{ padding: '2px' }}>
                                                            <input className="form-control" data-idx={x} value={adult.fname} type="text" /></td>
                                                        <td style={{ padding: '2px', width: '25%' }}>
                                                            <input className="form-control" data-idx={x} value={adult.lname} type="text" /></td>
                                                        {/*  <td style={{ padding: '2px', width: '9%' }}>
                                                            <input className="form-control" data-idx={x} type="text" value={adult.grade} /></td>
                                                        <td style={{ padding: '2px', textAlign: 'center', verticalAlign: 'middle', width: '5%' }}>
                                                            <input className="rdbox" data-idx={x} type="radio" checked={false} disabled /></td>
                                                        <td style={{ padding: '2px', textAlign: 'center', verticalAlign: 'middle', width: '5%' }}>
                                                            <input className="rdbox" data-idx={x} type="radio" checked={true} disabled /></td>
                                                        <td style={{ padding: '2px', textAlign: 'center', verticalAlign: 'middle', width: '7%' }}>
                                                            <input className="checkbox-inline" data-idx={x} type="checkbox" onChange={(e) => {
                                                                let idx = e.target.getAttribute('data-idx')
                                                                let _adultList = this.state.adultList;
                                                                _adultList[idx]['liveUnderFosterCare'] = e.target.checked;
                                                                this.setState({ adultList: _adultList })
                                                            }}
                                                                checked={adult.liveUnderFosterCare === true} /></td>
                                                        <td style={{ padding: '2px', verticalAlign: 'middle', width: '9%' }}>
                                                            <label className="checkbox-inline" style={{ display: 'block' }}>
                                                                <input type="checkbox" data-idx={x} value="Homeless" onChange={(e) => {
                                                                    let idx = e.target.getAttribute('data-idx')
                                                                    let _adultList = this.state.adultList;
                                                                    if (e.target.checked) {
                                                                        _adultList[idx].homelessOrMigrantOrRunawayOptions.push(e.target.value);
                                                                    } else {
                                                                        let index = _adultList[idx].homelessOrMigrantOrRunawayOptions.indexOf('Homeless')
                                                                        _adultList[idx].homelessOrMigrantOrRunawayOptions.splice(index, 1)
                                                                    }
                                                                    this.setState({ adultList: _adultList })
                                                                }}
                                                                    checked={(adult.homelessOrMigrantOrRunawayOptions || []).includes('Homeless')}
                                                                /><Trans>Homeless</Trans>
                                                            </label>
                                                            <label className="checkbox-inline" style={{ marginLeft: '0px', display: 'block' }}>
                                                                <input type="checkbox" data-idx={x} value="Migrant" onChange={(e) => {
                                                                    let idx = e.target.getAttribute('data-idx')
                                                                    let _adultList = this.state.adultList;
                                                                    if (e.target.checked) {
                                                                        _adultList[idx].homelessOrMigrantOrRunawayOptions.push(e.target.value);
                                                                    } else {
                                                                        let index = _adultList[idx].homelessOrMigrantOrRunawayOptions.indexOf('Migrant')
                                                                        _adultList[idx].homelessOrMigrantOrRunawayOptions.splice(index, 1)
                                                                    }
                                                                    this.setState({ adultList: _adultList })
                                                                }}
                                                                    checked={(adult.homelessOrMigrantOrRunawayOptions || []).includes('Migrant')}
                                                                /><Trans>Migrant</Trans>
                                                            </label>
                                                            <label className="checkbox-inline" style={{ marginLeft: '0px', display: 'block' }}>
                                                                <input type="checkbox" data-idx={x} value="Runaway" onChange={(e) => {
                                                                    let idx = e.target.getAttribute('data-idx')
                                                                    let _adultList = this.state.adultList;
                                                                    if (e.target.checked) {
                                                                        _adultList[idx].homelessOrMigrantOrRunawayOptions.push(e.target.value);
                                                                    } else {
                                                                        let index = _adultList[idx].homelessOrMigrantOrRunawayOptions.indexOf('Runaway')
                                                                        _adultList[idx].homelessOrMigrantOrRunawayOptions.splice(index, 1)
                                                                    }
                                                                    this.setState({ adultList: _adultList })
                                                                }}
                                                                    checked={(adult.homelessOrMigrantOrRunawayOptions || []).includes('Runaway')}
                                                                /><Trans>Runaway</Trans>
                                                            </label>
                                                        </td> */}
                                                        <td className="text-right">
                                                            <button className="btn-facebook-link" style={{ fontSize: '12px' }} onClick={(event) => this.handleRemoveAdult(event, x)}>
                                                                <i className="fa fa-trash"></i></button>
                                                        </td>
                                                    </tr>
                                                )
                                            })

                                        }

                                    </tbody>
                                    <tfoot>
                                        <tr>

                                            <td >
                                                <input className="form-control" value={this.state.adultFname} type="text" placeholder='First Name' onChange={(e) => this.setState({ adultFname: e.target.value })} />
                                            </td>
                                            <td >
                                                <input className="form-control" value={this.state.adultLname} type="text" placeholder='Last Name' onChange={(e) => this.setState({ adultLname: e.target.value })} />
                                            </td>
                                            <td>
                                                <button className="btn-social btn-linkedin-link pull-right" onClick={this.handleAddAdult}><Trans>Add Adult</Trans></button>
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="row assistance-program-section">
                        <div className="col-md-12">
                            <label><Trans>Do any Household Members (including you) currently participate in one or more of the following assistance programs</Trans>: SNAP, TANF, or FDPIR? </label>
                        </div>
                        <div className="col-md-12">
                            <ul className="list-unstyled para-list">
                                {person[0].assistancePrograms.map((program, p) => {

                                    return <li key={p}>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <i className="fa fa-hand-o-right" aria-hidden="true"></i>
                                                <input className="chbox" type="checkbox" data-idx={p} checked={program.isApplicable == true} onChange={(e) => {
                                                    let idx = e.target.getAttribute('data-idx');
                                                    let _person = this.state.person
                                                    _person[0].assistancePrograms[idx]['isApplicable'] = e.target.checked ? true : false;
                                                    this.setState({ person: person });
                                                }} /> <Trans>{program.name}</Trans>
                                            </div>{program.isApplicable == true ?
                                                <div className="col-md-3">
                                                    <input type="text" className="form-control" data-idx={p} placeholder={'Case Number'} value={program.caseNumber} onChange={(e) => {
                                                        let idx = e.target.getAttribute('data-idx');
                                                        let _person = this.state.person;
                                                        _person[0].assistancePrograms[idx]['caseNumber'] = e.target.value;
                                                        this.setState({ person: _person });
                                                    }} />
                                                </div> : null
                                            }

                                        </div>
                                    </li>
                                })}
                            </ul>
                        </div>
                    </div>
                    <div className="row income-section-1">
                        <div className="col-md-12">
                            <label><Trans>Report Income for ALL Household Members</Trans> </label>
                        </div>
                    </div>
                    <div className="row income-section-2">
                        <div className="col-md-12">
                            <div className="table-responsive">

                                <table className="table table-bordered table-income" cellPadding="0" cellSpacing="0">
                                    <thead>
                                        <tr>
                                            <th rowSpan="2"><Trans>First Name</Trans></th>
                                            <th rowSpan="2"><Trans>Last Name</Trans></th>
                                            <th colSpan="4"><Trans>Income ($)</Trans></th>
                                        </tr>
                                        <tr>
                                            <th><Trans>Source</Trans></th>
                                            <th><Trans>Frequency</Trans></th>
                                            <th><Trans>Amount</Trans></th>
                                            {/* <th>Income ($) (Annual)</th> */}
                                            <th width="50px"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            studentsList.map((student, k) => {
                                                return (
                                                    <Fragment>
                                                        <tr>
                                                            <td className="fname" rowSpan={student.income.length + 1}>
                                                                <input type="text" className="form-control" value={student.fname} /></td>
                                                            <td className="lname" rowSpan={student.income.length + 1}>
                                                                <input type="text" className="form-control" value={student.lname} />
                                                                <button type="button" data-midx={k} className="btn-facebook-link text-right" style={{ fontSize: '12px' }} onClick={(e) => {
                                                                    let midx = e.target.getAttribute('data-midx');
                                                                    let _studentsList = this.state.studentsList;
                                                                    _studentsList[midx].income.push(JSON.parse(JSON.stringify(incomeModal)))
                                                                    this.setState({ studentsList: _studentsList });
                                                                }}><Trans>Add income source</Trans></button>
                                                            </td>
                                                            <td colSpan="4" style={{ padding: '0px', border: '0px' }}></td>
                                                        </tr>
                                                        {
                                                            student.income.map((inc, i) => {
                                                                return (
                                                                    <tr>
                                                                        <td className="incSource">
                                                                            <select className="form-control" data-midx={k} data-sidx={i} name='source'
                                                                                value={inc.source} onChange={(e) => {
                                                                                    let midx = e.target.getAttribute('data-midx');
                                                                                    let sidx = e.target.getAttribute('data-sidx');
                                                                                    let _studentsList = this.state.studentsList;
                                                                                    _studentsList[midx].income[sidx][e.target.name] = e.target.value
                                                                                    this.setState({ studentsList: _studentsList });
                                                                                }}>
                                                                                <option></option>

                                                                                 {
                                                                                    (() => {
                                                                                        const selectedSources = student.income
                                                                                            .map(v => v.source)
                                                                                            .filter(src => src !== '');

                                                                                        return childIncomeTypeList.map((incType, t) => {
                                                                                            const isDisabled =
                                                                                                selectedSources.includes(incType) && incType !== inc.source;

                                                                                            return (
                                                                                                <option key={t} value={incType} disabled={isDisabled}>
                                                                                                    <Trans>{incType}</Trans>
                                                                                                </option>
                                                                                            );
                                                                                        });
                                                                                    })()
                                                                                }
                                                                            </select>
                                                                        </td>
                                                                        <td className="freeqCol">
                                                                            <select className="form-control" data-midx={k} data-sidx={i} name='frequency'
                                                                                value={inc.frequency} onChange={(e) => {
                                                                                    let midx = e.target.getAttribute('data-midx');
                                                                                    let sidx = e.target.getAttribute('data-sidx');
                                                                                    let _studentsList = this.state.studentsList;
                                                                                    _studentsList[midx].income[sidx][e.target.name] = e.target.value
                                                                                    this.setState({ studentsList: _studentsList });
                                                                                }}>
                                                                                <option value={0}></option>
                                                                                {
                                                                                    IncomFreqency.map((freq, f) => {
                                                                                        return <option key={f} value={freq.value}><Trans>{freq.text}</Trans></option>
                                                                                    })
                                                                                }
                                                                            </select>
                                                                        </td>
                                                                        <td className="incomeCol">
                                                                            <input type="text" className="form-control" data-midx={k}
                                                                                data-sidx={i} name='amount' value={inc.amount} onChange={(e) => {
                                                                                    let midx = e.target.getAttribute('data-midx');
                                                                                    let sidx = e.target.getAttribute('data-sidx');
                                                                                    let _studentsList = this.state.studentsList;
                                                                                    _studentsList[midx].income[sidx][e.target.name] = e.target.value
                                                                                    _studentsList[midx].noIncome = false
                                                                                    this.setState({ studentsList: _studentsList });
                                                                                }} />
                                                                        </td>
                                                                        <td className="text-center">
                                                                            <button data-midx={k} data-sidx={i} className="btn-facebook-link" style={{ fontSize: '12px' }} onClick={(e) => {
                                                                                let midx = e.target.parentNode.getAttribute('data-midx');
                                                                                let sidx = e.target.parentNode.getAttribute('data-sidx');
                                                                                let _studentsList = this.state.studentsList;
                                                                                _studentsList[midx].income.splice(sidx, 1)
                                                                                this.setState({ studentsList: _studentsList });
                                                                            }}>
                                                                                <i className="fa fa-trash"></i></button>
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            })
                                                        }
                                                    </Fragment>
                                                )
                                            })
                                        }
                                        {
                                            childList.map((child, k) => {
                                                return (
                                                    <Fragment>
                                                        <tr>
                                                            <td className="fname" rowSpan={child.income.length + 1}>
                                                                <input type="text" className="form-control" value={child.fname} /></td>
                                                            <td className="lname" rowSpan={child.income.length + 1}>
                                                                <input type="text" className="form-control" value={child.lname} />
                                                                <button type="button" data-midx={k} className="btn-facebook-link text-right" style={{ fontSize: '12px' }} onClick={(e) => {
                                                                    let midx = e.target.getAttribute('data-midx');
                                                                    let _childList = this.state.childList;
                                                                    _childList[midx].income.push(JSON.parse(JSON.stringify(incomeModal)))
                                                                    this.setState({ childList: _childList });
                                                                }}><Trans>Add income source</Trans></button>
                                                            </td>
                                                            <td colSpan="4" style={{ padding: '0px', border: '0px' }}></td>
                                                        </tr>
                                                        {
                                                            child.income.map((inc, i) => {
                                                                return (
                                                                    <tr>
                                                                        <td className="incSource">
                                                                            <select className="form-control" data-midx={k} data-sidx={i} name='source'
                                                                                value={inc.source} onChange={(e) => {
                                                                                    let midx = e.target.getAttribute('data-midx');
                                                                                    let sidx = e.target.getAttribute('data-sidx');
                                                                                    let _childList = this.state.childList;
                                                                                    _childList[midx].income[sidx][e.target.name] = e.target.value
                                                                                    this.setState({ childList: _childList });
                                                                                }}>
                                                                                <option></option>
                                                                                 {
                                                                                    (() => {
                                                                                        const selectedSources = child.income
                                                                                            .map(v => v.source)
                                                                                            .filter(src => src !== '');

                                                                                        return childIncomeTypeList.map((incType, t) => {
                                                                                            const isDisabled =
                                                                                                selectedSources.includes(incType) && incType !== inc.source;

                                                                                            return (
                                                                                                <option key={t} value={incType} disabled={isDisabled}>
                                                                                                    <Trans>{incType}</Trans>
                                                                                                </option>
                                                                                            );
                                                                                        });
                                                                                    })()
                                                                                }
                                                                            </select>
                                                                        </td>
                                                                        <td className="freeqCol">
                                                                            <select className="form-control" data-midx={k} data-sidx={i} name='frequency'
                                                                                value={inc.frequency} onChange={(e) => {
                                                                                    let midx = e.target.getAttribute('data-midx');
                                                                                    let sidx = e.target.getAttribute('data-sidx');
                                                                                    let _childList = this.state.childList;
                                                                                    _childList[midx].income[sidx][e.target.name] = e.target.value
                                                                                    this.setState({ childList: _childList });
                                                                                }}>
                                                                                <option value={0}></option>
                                                                                {
                                                                                    IncomFreqency.map((freq, f) => {
                                                                                        return <option key={f} value={freq.value}><Trans>{freq.text}</Trans></option>
                                                                                    })
                                                                                }
                                                                            </select>
                                                                        </td>
                                                                        <td className="incomeCol">
                                                                            <input type="text" className="form-control" data-midx={k}
                                                                                data-sidx={i} name='amount' value={inc.amount} onChange={(e) => {
                                                                                    let midx = e.target.getAttribute('data-midx');
                                                                                    let sidx = e.target.getAttribute('data-sidx');
                                                                                    let _childList = this.state.childList;
                                                                                    _childList[midx].income[sidx][e.target.name] = e.target.value
                                                                                    _childList[midx].noIncome = false
                                                                                    this.setState({ childList: _childList });
                                                                                }} />
                                                                        </td>
                                                                        <td className="text-center">
                                                                            <button data-midx={k} data-sidx={i} className="btn-facebook-link" style={{ fontSize: '12px' }} onClick={(e) => {
                                                                                let midx = e.target.parentNode.getAttribute('data-midx');
                                                                                let sidx = e.target.parentNode.getAttribute('data-sidx');
                                                                                let _childList = this.state.childList;
                                                                                _childList[midx].income.splice(sidx, 1)
                                                                                this.setState({ childList: _childList });
                                                                            }}>
                                                                                <i className="fa fa-trash"></i></button>
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            })
                                                        }
                                                    </Fragment>
                                                )
                                            })
                                        }
                                        {
                                            person.map((adult, k) => {
                                                return (
                                                    <Fragment>
                                                        <tr>
                                                            <td className="fname" rowSpan={adult.income.length + 1}>
                                                                <input type="text" className="form-control" value={adult.fname} /></td>
                                                            <td className="lname" rowSpan={adult.income.length + 1}>
                                                                <input type="text" className="form-control" value={adult.lname} />
                                                                <button type="button" data-midx={k} className="btn-facebook-link text-right" style={{ fontSize: '12px' }} onClick={(e) => {
                                                                    let midx = e.target.getAttribute('data-midx');
                                                                    let _person = this.state.person;
                                                                    _person[midx].income.push(JSON.parse(JSON.stringify(incomeModal)))
                                                                    this.setState({ person: _person });
                                                                }}><Trans>Add income source</Trans></button></td>
                                                            <td colSpan="4" style={{ padding: '0px', border: '0px' }}></td>
                                                        </tr>
                                                        {
                                                            adult.income.map((inc, i) => {
                                                                return (
                                                                    <tr>
                                                                        <td className="incSource">
                                                                            <select className="form-control" data-midx={k} data-sidx={i} name='source' value={inc.source}
                                                                                onChange={(e) => {
                                                                                    let midx = e.target.getAttribute('data-midx');
                                                                                    let sidx = e.target.getAttribute('data-sidx');
                                                                                    let _person = this.state.person;
                                                                                    _person[midx].income[sidx][e.target.name] = e.target.value
                                                                                    this.setState({ person: _person });
                                                                                }}>
                                                                                <option></option>
                                                                                {
                                                                                    (() => {
                                                                                        const selectedSources = adult.income
                                                                                            .map(v => v.source)
                                                                                            .filter(src => src !== '');

                                                                                        return childIncomeTypeList.map((incType, t) => {
                                                                                            const isDisabled =
                                                                                                selectedSources.includes(incType) && incType !== inc.source;

                                                                                            return (
                                                                                                <option key={t} value={incType} disabled={isDisabled}>
                                                                                                    <Trans>{incType}</Trans>
                                                                                                </option>
                                                                                            );
                                                                                        });
                                                                                    })()
                                                                                }
                                                                            </select>
                                                                        </td>
                                                                        <td className="freeqCol">
                                                                            <select className="form-control" data-midx={k} data-sidx={i} name='frequency' value={inc.frequency}
                                                                                onChange={(e) => {
                                                                                    let midx = e.target.getAttribute('data-midx');
                                                                                    let sidx = e.target.getAttribute('data-sidx');
                                                                                    let _person = this.state.person;
                                                                                    _person[midx].income[sidx][e.target.name] = e.target.value
                                                                                    this.setState({ person: _person });
                                                                                }}>
                                                                                <option value={0}></option>
                                                                                {
                                                                                    IncomFreqency.map((freq, f) => {
                                                                                        return <option key={f} value={freq.value}><Trans>{freq.text}</Trans></option>
                                                                                    })
                                                                                }
                                                                            </select>
                                                                        </td>
                                                                        <td className="incomeCol"><input type="text" data-midx={k} data-sidx={i} name='amount'
                                                                            className="form-control" value={inc.amount}
                                                                            onChange={(e) => {
                                                                                let midx = e.target.getAttribute('data-midx');
                                                                                let sidx = e.target.getAttribute('data-sidx');
                                                                                let _person = this.state.person;
                                                                                _person[midx].income[sidx][e.target.name] = e.target.value
                                                                                _person[midx].noIncome = false
                                                                                this.setState({ person: _person });
                                                                            }}

                                                                        /></td>
                                                                        <td className="text-center">
                                                                            <button data-midx={k} data-sidx={i} className="btn-facebook-link" style={{ fontSize: '12px' }} onClick={(e) => {
                                                                                let midx = e.target.parentNode.getAttribute('data-midx');
                                                                                let sidx = e.target.parentNode.getAttribute('data-sidx');
                                                                                let _person = this.state.person;
                                                                                _person[midx].income.splice(sidx, 1)
                                                                                this.setState({ person: _person });
                                                                            }}>
                                                                                <i className="fa fa-trash"></i></button>
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            })
                                                        }

                                                    </Fragment>
                                                )

                                            })
                                        }
                                        {
                                            adultList.map((adult, k) => {
                                                return (
                                                    <Fragment>
                                                        <tr>
                                                            <td className="fname" rowSpan={adult.income.length + 1}>
                                                                <input type="text" className="form-control" value={adult.fname} /></td>
                                                            <td className="lname" rowSpan={adult.income.length + 1}>
                                                                <input type="text" className="form-control" value={adult.lname} />
                                                                <button type="button" data-midx={k} className="btn-facebook-link text-right" style={{ fontSize: '12px' }} onClick={(e) => {
                                                                    let midx = e.target.getAttribute('data-midx');
                                                                    let _adultList = this.state.adultList;
                                                                    _adultList[midx].income.push(JSON.parse(JSON.stringify(incomeModal)))
                                                                    this.setState({ adultList: _adultList, isStateChanged: true });
                                                                }}><Trans>Add income source</Trans></button></td>
                                                            <td colSpan="4" className="text-right" style={{ padding: '0px', border: '0px' }}>
                                                            </td>

                                                        </tr>
                                                        {
                                                            adult.income.map((inc, i) => {
                                                                return (
                                                                    <tr>
                                                                        <td className="incSource">
                                                                            <select className="form-control" data-midx={k} data-sidx={i} name='source' value={inc.source}
                                                                                onChange={(e) => {
                                                                                    let midx = e.target.getAttribute('data-midx');
                                                                                    let sidx = e.target.getAttribute('data-sidx');
                                                                                    let _adultList = this.state.adultList;
                                                                                    _adultList[midx].income[sidx][e.target.name] = e.target.value
                                                                                    this.setState({ adultList: _adultList });
                                                                                }}>
                                                                                <option></option>
                                                                                {
                                                                                    (() => {
                                                                                        const selectedSources = adult.income
                                                                                            .map(v => v.source)
                                                                                            .filter(src => src !== '');

                                                                                        return childIncomeTypeList.map((incType, t) => {
                                                                                            const isDisabled =
                                                                                                selectedSources.includes(incType) && incType !== inc.source;

                                                                                            return (
                                                                                                <option key={t} value={incType} disabled={isDisabled}>
                                                                                                    <Trans>{incType}</Trans>
                                                                                                </option>
                                                                                            );
                                                                                        });
                                                                                    })()
                                                                                }
                                                                            </select>
                                                                        </td>
                                                                        <td className="freeqCol">
                                                                            <select className="form-control" data-midx={k} data-sidx={i} name='frequency'
                                                                                value={inc.frequency} onChange={(e) => {
                                                                                    let midx = e.target.getAttribute('data-midx');
                                                                                    let sidx = e.target.getAttribute('data-sidx');
                                                                                    let _adultList = this.state.adultList;
                                                                                    _adultList[midx].income[sidx][e.target.name] = e.target.value
                                                                                    this.setState({ adultList: _adultList });
                                                                                }}>
                                                                                <option value={0}></option>
                                                                                {
                                                                                    IncomFreqency.map((freq, f) => {
                                                                                        return <option key={f} value={freq.value}><Trans>{freq.text}</Trans></option>
                                                                                    })
                                                                                }
                                                                            </select>
                                                                        </td>
                                                                        <td className="incomeCol">
                                                                            <input type="text" className="form-control" data-midx={k} data-sidx={i} name='amount' value={inc.amount} onChange={(e) => {
                                                                                let midx = e.target.getAttribute('data-midx');
                                                                                let sidx = e.target.getAttribute('data-sidx');
                                                                                let _adultList = this.state.adultList;
                                                                                _adultList[midx].income[sidx][e.target.name] = e.target.value
                                                                                _adultList[midx].noIncome = false
                                                                                this.setState({ adultList: _adultList });
                                                                            }} /></td>
                                                                        <td className="text-center">
                                                                            <button data-midx={k} data-sidx={i} className="btn-facebook-link" style={{ fontSize: '12px' }} onClick={(e) => {
                                                                                let midx = e.target.parentNode.getAttribute('data-midx');
                                                                                let sidx = e.target.parentNode.getAttribute('data-sidx');
                                                                                let _adultList = this.state.adultList;
                                                                                _adultList[midx].income.splice(sidx, 1)
                                                                                this.setState({ adultList: _adultList });
                                                                            }}>
                                                                                <i className="fa fa-trash"></i></button>
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            })
                                                        }

                                                    </Fragment>
                                                )

                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="row contact-section-1">
                        <div className="col-md-12" style={{ paddingBottom: '20px' }}>
                            <label><Trans>Contact information</Trans></label>
                        </div>
                    </div>
                    <div className="row contact-section-2">
                        <div className="col-md-4">
                            <label><Trans>Phone</Trans></label>
                            <input type="text" name="phone" className="form-control" onKeyPress={numberOnly}
                                onChange={(e) => {
                                    let _person = this.state.person
                                    _person[0].contact.phone = e.target.value
                                    this.setState({ person: _person })
                                }}
                                value={this.state.person[0].contact.phone} />
                        </div>
                        <div className="col-md-4">
                            <label><Trans>Address 1</Trans></label>
                            <input type="text" name="street1" className="form-control"
                                onChange={(e) => {
                                    let _person = this.state.person
                                    _person[0].contact.street1 = e.target.value
                                    this.setState({ person: _person })
                                }}
                                value={this.state.person[0].contact.address1} />
                        </div>
                        <div className="col-md-4">
                            <label><Trans>Address 2</Trans></label>
                            <input type="text" name="street2" className="form-control"
                                onChange={(e) => {
                                    let _person = this.state.person
                                    _person[0].contact.street2 = e.target.value
                                    this.setState({ person: _person })
                                }}
                                value={this.state.person[0].contact.address2} />
                        </div>
                    </div>
                    <div className="row contact-section-3">

                        <div className="col-md-4">
                            <label><Trans>City</Trans></label>
                            <input type="text" name="city" className="form-control"
                                onChange={(e) => {
                                    let _person = this.state.person
                                    _person[0].contact.city = e.target.value
                                    this.setState({ person: _person })
                                }}
                                value={this.state.person[0].contact.city} />
                        </div>
                        <div className="col-md-4">
                            <label><Trans>State</Trans></label>
                            <select name="state" className="form-control"
                                onChange={(e) => {
                                    let _person = this.state.person
                                    _person[0].contact.state = e.target.value
                                    this.setState({ person: _person })
                                }}
                                value={this.state.person[0].contact.state}>
                                <option value=""></option><option value="AL">Alabama</option><option value="AK">Alaska</option><option value="AZ">Arizona</option><option value="AR">Arkansas</option><option value="CA">California</option><option value="CO">Colorado</option><option value="CT">Connecticut</option><option value="DE">Delaware</option><option value="DC">District of Columbia</option><option value="FL">Florida</option><option value="GA">Georgia</option><option value="HI">Hawaii</option><option value="ID">Idaho</option><option value="IL">Illinois</option><option value="IN">Indiana</option><option value="IA">Iowa</option><option value="KS">Kansas</option><option value="KY">Kentucky</option><option value="LA">Louisiana</option><option value="ME">Maine</option><option value="MD">Maryland</option><option value="MA">Massachusetts</option><option value="MI">Michigan</option><option value="MN">Minnesota</option><option value="MS">Mississippi</option><option value="MO">Missouri</option><option value="MT">Montana</option><option value="NE">Nebraska</option><option value="NV">Nevada</option><option value="NH">New Hampshire</option><option value="NJ">New Jersey</option><option value="NM">New Mexico</option><option value="NY">New York</option><option value="NC">North Carolina</option><option value="ND">North Dakota</option><option value="OH">Ohio</option><option value="OK">Oklahoma</option><option value="OR">Oregon</option><option value="PA">Pennsylvania</option><option value="RI">Rhode Island</option><option value="SC">South Carolina</option><option value="SD">South Dakota</option><option value="TN">Tennessee</option><option value="TX">Texas</option><option value="UT">Utah</option><option value="VT">Vermont</option><option value="VA">Virginia</option><option value="WA">Washington</option><option value="WV">West Virginia</option><option value="WI">Wisconsin</option><option value="WY">Wyoming</option>
                            </select>
                        </div>
                        <div className="col-md-4">
                            <label><Trans>Zip</Trans></label>
                            <input type="text" name="zip" className="form-control"
                                onChange={(e) => {
                                    let _person = this.state.person
                                    _person[0].contact.zip = e.target.value
                                    this.setState({ person: _person })
                                }}
                                value={this.state.person[0].contact.zip} />
                        </div>
                    </div>
                    <div className="row contact-section-5">
                        <div className="col-md-12" >
                            <label><Trans>Last Four Digits of Social Security Number (SSN) of Primary Wage Earner or Other Adult Household Member</Trans></label>
                            <div className="row">
                                <div className="col-md-4">
                                    <input type="text" name="ssn" className="form-control text-right" minLength="4" maxLength="4" disabled={this.state.person[0].noSSN}
                                        placeHolder={'XXXX'} value={this.state.person[0].noSSN ? '' : this.state.person[0].ssn} onChange={(e) => {
                                            let _person = this.state.person
                                            _person[0].ssn = this.state.person[0].noSSN ? '' : e.target.value
                                            this.setState({ person: _person })
                                        }}
                                        onKeyPress={numberOnly} />
                                </div>
                                <div className="col-md-4">
                                    <div style={{ marginTop: '7px' }}>
                                        <input type="checkbox" name="noSSN"
                                            checked={this.state.person.noSSN} onChange={(e) => {
                                                let _person = this.state.person
                                                _person[0].noSSN = e.target.checked
                                                if (e.target.checked) {
                                                    _person[0].ssn = ''
                                                }
                                                this.setState({ person: _person })
                                            }} /> <label><Trans>No SSN</Trans></label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {studentsList.length > 0 ?
                        <div className="row identity-section mt-5">
                            <div className="col-xs-12">
                                <label><Trans>Children's Racial and Ethnic Identities</Trans></label>
                            </div>
                        </div> : null
                    }
                    <div className="row identity-section">
                        <div className="col-xs-12" >
                            {
                                studentsList.map((item, k) => {
                                    return (
                                        <div className="row">
                                            <div className="col-md-12">
                                                <h5>{item.lname + ' ' + item.fname}</h5>
                                                <div className="col-md-4">
                                                    <label><Trans>{'Ethnicity'}</Trans></label><br />
                                                    <input className="rdbox" type="radio" name={"ethnicity" + k + '-' + this.props.id} data-idx={k} checked={item.ethenticity === 'Hispanic or Latino'} onChange={(e) => {
                                                        let idx = e.target.getAttribute('data-idx');
                                                        let _studentsList = this.state.studentsList;
                                                        _studentsList[idx]['ethenticity'] = e.target.checked ? 'Hispanic or Latino' : '';
                                                        this.setState({ studentsList: _studentsList });

                                                    }} /> <label><Trans>Hispanic or Latino</Trans></label><br />
                                                    <input className="rdbox" type="radio" name={"ethnicity" + k + '-' + this.props.id} data-idx={k} checked={item.ethenticity === 'Not Hispanic or Latino'} onChange={(e) => {
                                                        let idx = e.target.getAttribute('data-idx')
                                                        let _studentsList = this.state.studentsList;
                                                        _studentsList[idx]['ethenticity'] = e.target.checked ? 'Not Hispanic or Latino' : '';
                                                        this.setState({ studentsList: _studentsList });

                                                    }} /> <label><Trans>Not Hispanic or Latino</Trans></label>
                                                </div>
                                                <div className="col-md-6">
                                                    <label><Trans>{'Race'}</Trans></label><br />
                                                    <input className="chbox" type="checkbox" name={"AIAN" + k} data-idx={k}
                                                        checked={(item.race).includes('American Indian or Alaskan Native') || false}
                                                        onChange={(e) => {
                                                            let idx = e.target.getAttribute('data-idx')
                                                            let value = 'American Indian or Alaskan Native'
                                                            let _studentsList = this.state.studentsList;
                                                            let raceArray = []
                                                            if (_studentsList[idx].race.length > 0) {
                                                                raceArray = _studentsList[idx].race;
                                                            }
                                                            if (_studentsList[idx].race.includes(value)) {
                                                                var _idx = raceArray.indexOf(value);
                                                                if (_idx > -1) {
                                                                    raceArray.splice(_idx, 1);
                                                                }
                                                            }
                                                            if (e.target.checked) {
                                                                raceArray.push(value);
                                                            }
                                                            _studentsList[idx].race = raceArray
                                                            this.setState({ studentsList: _studentsList });

                                                        }} /> <label><Trans>American Indian or Alaskan Native</Trans></label><br />
                                                    <input className="chbox" type="checkbox" id={"Asian" + k} name={"Asian" + k} data-idx={k}
                                                        checked={item.race.includes('Asian')}
                                                        onChange={(e) => {
                                                            let idx = e.target.getAttribute('data-idx');
                                                            let value = 'Asian'
                                                            let _studentsList = this.state.studentsList;
                                                            let raceArray = []
                                                            if (_studentsList[idx].race.length > 0) {
                                                                raceArray = _studentsList[idx].race;
                                                            }
                                                            if (_studentsList[idx].race.includes(value)) {
                                                                var _idx = raceArray.indexOf(value);
                                                                if (_idx > -1) {
                                                                    raceArray.splice(_idx, 1);
                                                                }
                                                            }
                                                            if (e.target.checked) {
                                                                raceArray.push(value);
                                                            }
                                                            _studentsList[idx].race = raceArray
                                                            this.setState({ studentsList: _studentsList });
                                                        }} /> <label><Trans>Asian</Trans></label><br />
                                                    <input className="chbox" type="checkbox" id={"BAA" + k} name={"BAA" + k} data-idx={k}
                                                        checked={item.race.includes('Black or African American')}
                                                        onChange={(e) => {
                                                            let idx = e.target.getAttribute('data-idx')
                                                            let value = 'Black or African American'
                                                            let _studentsList = this.state.studentsList;
                                                            let raceArray = []
                                                            if (_studentsList[idx].race.length > 0) {
                                                                raceArray = _studentsList[idx].race;
                                                            }
                                                            if (_studentsList[idx].race.includes(value)) {
                                                                var _idx = raceArray.indexOf(value);
                                                                if (_idx > -1) {
                                                                    raceArray.splice(_idx, 1);
                                                                }
                                                            }
                                                            if (e.target.checked) {
                                                                raceArray.push(value);
                                                            }
                                                            _studentsList[idx].race = raceArray
                                                            this.setState({ studentsList: _studentsList });
                                                        }} /> <label><Trans>Black or African American</Trans></label><br />
                                                    <input className="chbox" type="checkbox" id={"NHOPI" + k} name={"NHOPI" + k} data-idx={k}
                                                        checked={item.race.includes('Native Hawaiian or Other Pacific Islander')}
                                                        onChange={(e) => {
                                                            let idx = e.target.getAttribute('data-idx')
                                                            let value = 'Native Hawaiian or Other Pacific Islander'
                                                            let _studentsList = this.state.studentsList;
                                                            let raceArray = []
                                                            if (_studentsList[idx].race.length > 0) {
                                                                raceArray = _studentsList[idx].race;
                                                            }
                                                            if (_studentsList[idx].race.includes(value)) {
                                                                var _idx = raceArray.indexOf(value);
                                                                if (_idx > -1) {
                                                                    raceArray.splice(_idx, 1);
                                                                }
                                                            }
                                                            if (e.target.checked) {
                                                                raceArray.push(value);
                                                            }
                                                            _studentsList[idx].race = raceArray
                                                            this.setState({ studentsList: _studentsList, isStateChanged: true });
                                                        }} /> <label><Trans>Native Hawaiian or Other Pacific Islander</Trans></label><br />
                                                    <input className="chbox" type="checkbox" id={"White" + k} name={"White" + k} data-idx={k}
                                                        checked={item.race.includes('White')}
                                                        onChange={(e) => {
                                                            let idx = e.target.getAttribute('data-idx')
                                                            let value = 'White'
                                                            let _studentsList = this.state.studentsList;
                                                            let raceArray = []
                                                            if (_studentsList[idx].race.length > 0) {
                                                                raceArray = _studentsList[idx].race;
                                                            }
                                                            if (_studentsList[idx].race.includes(value)) {
                                                                var _idx = raceArray.indexOf(value);
                                                                if (_idx > -1) {
                                                                    raceArray.splice(_idx, 1);
                                                                }
                                                            }
                                                            if (e.target.checked) {
                                                                raceArray.push(value);
                                                            }
                                                            _studentsList[idx].race = raceArray
                                                            this.setState({ studentsList: _studentsList });

                                                        }} /> <label><Trans>White</Trans></label>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                                )
                            }
                        </div>
                    </div>
                    <div className="row">
                        <div className='col-md-12 text-right' style={{ marginTop: '5px', marginBottom: '5px' }}>
                            <button className="btn btn-xs btn-danger" onClick={(e) => this.onCancel(e)}>
                                <Trans>Cancel</Trans>
                            </button>
                            <button className="btn btn-xs btn-success" onClick={(e) => this.onFormSubmit(e)} disabled={disablebtn}>
                                <Trans>Submit</Trans>
                            </button>
                        </div>
                    </div>
                </Form>
            </div>
        )
    }
}


NewSchoolMealProgramApplication.contextTypes = {
    router: PropTypes.object.isRequired
};


export default NewSchoolMealProgramApplication;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/SchoolMealProgram/newSchoolProgramApplication.js